export enum ApiKeyAccessLevel {
  None,
  Read,
  Write,
}
